module.exports = __webpack_public_path__ + "img/back6.0d159900.png";